export function roles(api: ReturnType<typeof useAxios>) {
  const getAllRoles = async (data: any) =>
    await api.$get(
      `/roles?limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}&search=${encodeURIComponent(data.search)}&status=${data.status}`,
    );
  const getAllPermission = async () => await api.$get(`/permissions`);
  const createRole = async (data: any) => await api.$post(`/roles`, data);
  const getRole = async (id: any) => await api.$get(`/roles/${id}`);
  const deleteRole = async (id: any) => await api.$delete(`/roles/${id}`);
  const updateRole = async (id: any, data: any) => await api.$put(`/roles/${id}`, data);
  const roleList = async (id: any) => await api.$get(`/roles/list?id=${id}`);
  const updateRoleStatus = async (id: string, data: any) => await api.$put(`/roles/status/${id}`, data);

  return {
    getAllRoles,
    getAllPermission,
    createRole,
    deleteRole,
    getRole,
    updateRole,
    roleList,
    updateRoleStatus,
  };
}
